import React, { useEffect, useState } from "react";
import "./Properties Tab.css";
import closeIcon from "../../Assets/popup-close.svg";
import CanvasProperties from "./Canvas Properties";
import { IconButton, } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';

const PropertiesTab = ({
  onHandleClose,
  node,
  nodeId,
  edgeId,
  initialLabel,
  type,
  onUpdateNode,
  onUpdateEdge,
  edgeLabel,
  edgeStyle,
  recData,
  permissionData,
  currentTab,
  selectedEventLevel,
  dropdownPropsTabData,
  allRolesData,
  allCompletionRule,
  onSaveRoleAccess,
  handlePermissionChange,
  onSaveConstraints,
  propPermission,
  sequenceNumber,
  handleOrderByChange,
  ruleEngineEvents,
  sequenceNumberValues,
  onReorderSequence,
}) => {
  const [activeTab, setActiveTab] = useState(1);
  const [orderByEvents, setOrderByEvents] = useState(sequenceNumber);
  const [nodeBackgroundColor, setNodeBackgroundColor] = useState("#fff");
  const [nodeFontColor, setNodeFontColor] = useState("#fff");


  const permissions = propPermission
    ? propPermission.split(",").map(Number)
    : [];

  const createCondition = () => ({
    id: Date.now() + Math.random(),
    // dependsOn:
    //   selectedEventLevel?.length > 0
    //     ? String(selectedEventLevel[0].id)
    //     : "",
    dependsOn:"",
    condition: "AND",
  });

  const createSubflowRule = () => ({
    id: Date.now() + Math.random(),
    ruleEngine1EventId: "",
    ruleEngine2EventId: "",
    conditionRule: "",
  });

  const [completionRules, setCompletionRules] = useState({
    ruleName: "",
    subflowRules: [createSubflowRule()],   // ✅ Subflow rows
    conditions: [createCondition()],       // ✅ Workflow rows
  });

  const handleAdd = () => {
    if (currentTab === "Subflow") {
      setCompletionRules((prev) => ({
        ...prev,
        subflowRules: [...(prev.subflowRules || []), createSubflowRule()],
      }));
    } else {
      setCompletionRules((prev) => ({
        ...prev,
        conditions: [...(prev.conditions || []), createCondition()],
      }));
    }
  };
  const removeSubflowRule = (id) => {
    setCompletionRules((prev) => ({
      ...prev,
      subflowRules: prev.subflowRules.filter((r) => r.id !== id),
    }));
  };

  const removeCondition = (id) => {
    setCompletionRules((prev) => ({
      ...prev,
      conditions: prev.conditions.filter((c) => c.id !== id),
    }));
  };

  const handleSaveClick = () => {
    onSaveConstraints({
      completionRules,
      node,
      onUpdateNode,
    });
  };

  useEffect(() => {
    //setActiveTab(1);   
    if (node?.data?.label) {
      setCompletionRules({
        ruleName: node.data.label,
        conditions: [
          {
            id: Date.now(),
            dependsOn: String(node.data.eventId),
            condition: "AND",
          },
        ],
      });
      return;
    }
  }, [nodeId, edgeId, node]);

  useEffect(() => {
    if (!node?.data?.label || !selectedEventLevel?.length) return;
    // Determine the previous item in the dropdown
    const index = selectedEventLevel.findIndex(
      (event) => event.displayName === node.data.label
    );

    let dependsOnValue = "";
    if (index > 0) {
      dependsOnValue = String(selectedEventLevel[index - 1].id);
    }

  }, [node, selectedEventLevel, allCompletionRule, currentTab]);

  useEffect(() => {
    if (!node) return;
    setCompletionRules((prev) => {
      // ✅ prevent overwrite if already exists
      if (prev.subflowRules && prev.subflowRules.length > 0) {
        return prev;
      }

      return {
        ...prev,
        ruleName: node?.data?.label || "",
        subflowRules: [createSubflowRule()], // only once
        conditions: [createCondition()],
      };
    });
    setNodeBackgroundColor(node?.data?.color);
    setNodeFontColor(node?.data?.fontColor);    
  }, [node]);

  useEffect(() => {
    // do whatever you need with propPermission
  }, [propPermission]);


  useEffect(() => {
    if (sequenceNumberValues?.length && sequenceNumber) {
      const selected = sequenceNumberValues.find(
        (item) => item.sequenceNumber === Number(sequenceNumber)
      );
      setOrderByEvents(selected);
    }
  }, [sequenceNumber, sequenceNumberValues]);


  useEffect(() => {
    if (currentTab !== "Subflow") return;

    if (allCompletionRule && allCompletionRule.length > 0) {
      setCompletionRules((prev) => ({
        ...prev,
        subflowRules: allCompletionRule, // ✅ API wins
      }));
    }
  }, [allCompletionRule, currentTab]);

  const getEventName = (id) => ruleEngineEvents?.find(e => e.constraintId === id)?.constraint || "Select Constraint Field";
  const getEventConstraint = (id) => ruleEngineEvents?.find(e => e.constraintValueId === id)?.name || "Possible Constraint Values";

  const handleReOrderSaveClick = () => {
    if (!orderByEvents) return;

    onReorderSequence({
      id: orderByEvents.id,
      sequenceNumber: orderByEvents.sequenceNumber,
      nodeId: nodeId
    });
  };
  // const getFilteredValues = (rule) => {
  //   return ruleEngineEvents?.filter(
  //     (item) =>
  //       item.workFlowEventConstraintId === rule.ruleEngine1EventId
  //   ) || [];
  // };
  const getFilteredValues = (rule) => {
    return ruleEngineEvents?.filter(
      (item) => item.constraintId === rule.ruleEngine1EventId
    );
  };
  return (
    <div className="properties-panel" style={{ width: '400px', padding: '15px' }}>
      {/* HEADER */}
      <div className="properties-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontWeight: 'bold', fontSize: '18px' }}>  {node?.data?.label} </span>
        <img
          src={closeIcon}
          alt="close"
          style={{ cursor: 'pointer', width: '18px' }}
          onClick={onHandleClose}
        />
      </div>

      {/* TABS */}
      <ul className="properties-tabs" style={{ display: 'flex', listStyle: 'none', padding: 0, marginTop: '10px', borderBottom: '1px solid #ccc' }}>
        {["General", "Advance", "Permission"].map((tab, index) => (
          <li
            key={tab}
            onClick={() => setActiveTab(index)}
            style={{
              cursor: "pointer",
              padding: "8px 5px",
              borderBottom: activeTab === index ? "3px solid #1DA1F2" : "none",
              color: activeTab === index ? "#1DA1F2" : "#555",
              fontWeight: activeTab === index ? "500" : "400",
            }}
          >
            {tab}
          </li>
        ))}
      </ul>

      {/* CONTENT */}
      <div className="properties-content" style={{ marginTop: '20px' }}>
        {activeTab === 0 && (
          <>
            {activeTab === 0 && currentTab === "Subflow" &&  (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                justifyContent: "center"
              }}
            >
           
               
              <span>Sequence By Event</span>

              <select
                value={orderByEvents?.id || ""}   // ✅ use id
                onChange={(e) => {
                  const selected = sequenceNumberValues.find(
                    (item) => item.id === Number(e.target.value)
                  );
                  setOrderByEvents(selected);
                }}
                style={{
                  width: "80px",
                  padding: "6px",
                  border: "1px solid #ccc",
                  borderRadius: "4px"
                }}
              >
                <option value="">Select</option>

                {sequenceNumberValues?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.sequenceNumber}
                  </option>
                ))}
              </select>
            
          
              <button
                onClick={handleReOrderSaveClick}
                style={{
                  backgroundColor: "#02ACF6",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  height: "32px",
                  padding: "0 12px",
                  cursor: "pointer",
                  fontWeight: "600"
                }}
              >
                Reorder
              </button>  
              
            </div>    )}
   <br></br>
            <CanvasProperties
              nodeId={nodeId}
              nodeColor={nodeBackgroundColor}
              fontColor={nodeFontColor}
              initialLabel={initialLabel}
              type={type}
              edgeId={edgeId}
              edgeLabel={edgeLabel}
              edgeStyles={edgeStyle}
              onUpdateNode={onUpdateNode}
              onUpdateEdge={onUpdateEdge}
              currentTab={currentTab}
            />
          </>
        )}

        {activeTab === 1 && (
          <div>
            <label style={{ fontWeight: "600", fontSize: "14px" }}>
              Completion Rules
            </label>

            {/* Rule Name */}
            <input
              type="text"
              value={completionRules.ruleName}
              onChange={(e) =>
                setCompletionRules((prev) => ({
                  ...prev,
                  ruleName: e.target.value,
                }))
              }
              placeholder="Rule name"
              style={{
                width: "90%",
                padding: "7px 8px",
                marginTop: "5px",
                marginBottom: "15px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />

            {/* ================= SUBFLOW ================= */}
            {currentTab === "Subflow" && (
              <div
                style={{
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  background: "#fafafa",
                }}
              >
                {completionRules.subflowRules?.map((rule, index) => (
                  <React.Fragment key={rule.id}>

                    {/* ✅ Rule Row */}
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>

                      {/* Rule 1 */}
                      <Tooltip title={getEventName(rule.ruleEngine1EventId)}>
                        <select value={rule.ruleEngine1EventId ?? ""}
                          onChange={(e) =>
                            setCompletionRules((prev) => ({
                              ...prev,
                              subflowRules: prev.subflowRules.map((r) =>
                                r.id === rule.id
                                  ? {
                                    ...r,
                                    ruleEngine1EventId: Number(e.target.value),
                                    ruleEngine2EventId: "", // 👈 reset dependent field
                                  }
                                  : r
                              ),
                            }))
                          }
                          style={{ flex: 1, marginRight: "6px", padding: "6px", width: "100px" }}
                        >
                          <option value="" hidden>Select Constraint Field</option>

                          {/* unique constraints */}
                          {[...new Map(ruleEngineEvents.map(item => [item.constraintId, item])).values()]
                            .map((item) => (
                              <option key={item.constraintId} value={item.constraintId}>
                                {item.callOutName}
                              </option>
                            ))}
                        </select>
                      </Tooltip>

                      {/* Operator inside rule */}
                      <select
                        value={rule.conditionRule ?? ""}
                        onChange={(e) =>
                          setCompletionRules((prev) => ({
                            ...prev,
                            subflowRules: prev.subflowRules.map((r) =>
                              r.id === rule.id
                                ? { ...r, conditionRule: e.target.value }
                                : r
                            ),
                          }))
                        }
                        style={{ width: "40px", marginRight: "6px", padding: "6px" }}
                      >
                        <option value="" hidden>Select Operator</option>

                        {/* <option value="AND">&&</option>*/}
                        <option value="NotEQUAL">!=</option>
                        <option value="EQUAL">=</option>
                        <option value="LessThan">&lt;</option>
                        <option value="GreaterThan">&gt;</option>
                      </select>

                      {/* Rule 2 */}
                      <Tooltip title={getEventConstraint(rule.ruleEngine2EventId)}>
                        <select value={rule.ruleEngine2EventId ?? ""}
                          onChange={(e) =>
                            setCompletionRules((prev) => ({
                              ...prev,
                              subflowRules: prev.subflowRules.map((r) =>
                                r.id === rule.id
                                  ? { ...r, ruleEngine2EventId: Number(e.target.value) }
                                  : r
                              ),
                            }))
                          }
                          disabled={!rule.ruleEngine1EventId} // 👈 UX improvement
                          style={{ flex: 1, padding: "6px", width: "100px", marginRight: "3px" }}
                        >
                          <option value="" hidden>Possible Constraint Values</option>

                          {getFilteredValues(rule).map((item) => (
                            <option key={item.constraintValueId} value={item.constraintValueId}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </Tooltip>
                      {/* ✅ Between Operator (ONLY between rows) */}
                      {index < completionRules.subflowRules.length - 1 && (
                        <div style={{ marginBottom: "0px", textAlign: "center" }}>
                          <select
                            value={
                              completionRules.subflowRules[index]?.nextCondition !== undefined
                                ? completionRules.subflowRules[index].nextCondition
                                : "AND"
                            }
                            onChange={(e) =>
                              setCompletionRules((prev) => {
                                const updatedRules = [...prev.subflowRules];

                                updatedRules[index] = {
                                  ...updatedRules[index],
                                  nextCondition: e.target.value, // ✅ store between operator
                                };

                                return {
                                  ...prev,
                                  subflowRules: updatedRules,
                                };
                              })
                            }
                            style={{ width: "60px", padding: "6px" }}
                          >
                            <option value="AND">AND</option>
                            <option value="OR">OR</option>
                          </select>
                        </div>
                      )}
                      {/* Delete */}
                      <IconButton
                        onClick={() => removeSubflowRule(rule.id)}
                        sx={{ color: "red" }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </div>


                  </React.Fragment>
                ))}
              </div>
            )}

            {/* ================= WORKFLOW ================= */}
            {currentTab === "Workflow" &&
              completionRules.conditions?.map((cond) => (
                <div
                  key={cond.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                    border: "1px solid #eee",
                    padding: "8px",
                    borderRadius: "6px",
                  }}
                >
                  {/* AND / OR */}
                  <select
                    value={cond.condition}
                    onChange={(e) =>
                      setCompletionRules((prev) => ({
                        ...prev,
                        conditions: prev.conditions.map((c) =>
                          c.id === cond.id
                            ? { ...c, condition: e.target.value }
                            : c
                        ),
                      }))
                    }
                    style={{
                      width: "70px",
                      marginRight: "6px",
                      padding: "6px",
                    }}
                  >
                    <option value="AND">AND</option>
                    <option value="OR">OR</option>
                  </select>

                  {/* Depends On */}
                  <select
                    value={cond.dependsOn}
                    onChange={(e) =>
                      setCompletionRules((prev) => ({
                        ...prev,
                        conditions: prev.conditions.map((c) =>
                          c.id === cond.id
                            ? { ...c, dependsOn: e.target.value }
                            : c
                        ),
                      }))
                    }
                    style={{
                      flex: 1,
                      padding: "6px",                      
                    }}
                  >
                    <option value="">Select Level</option>
                    {selectedEventLevel?.map((event) => (
                      <option key={event.id} value={event.id}>
                        {event.displayName}
                      </option>
                    ))}
                  </select>

                  {/* Delete */}
                  <IconButton
                    onClick={() => removeCondition(cond.id)}
                    sx={{ color: "red", marginLeft: "6px" }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </div>
              ))}

            {/* ADD BUTTON */}
            <button onClick={handleAdd}
              style={{
                marginTop: "10px",
                background: "transparent",
                border: "1px solid #1DA1F2",
                color: "#1DA1F2",
                padding: "6px 12px",
                borderRadius: "4px",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >+ Add</button>

            {/* SAVE */}
            <button onClick={handleSaveClick}
              style={{
                marginTop: "25px",
                width: "100%",
                backgroundColor: "#02ACF6",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                height: "35px",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >Save Constraints</button>
          </div>
        )}

        {activeTab === 2 && currentTab === "Workflow" && (
          <div
            style={{
              width: "350px",
              border: "1px solid #ddd",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                borderBottom: "1px solid #ddd",
                fontWeight: "bold",
                padding: "10px 5px",
              }}
            >
              <div style={{ flex: "2", paddingLeft: "10px" }}>Role</div>
              <div style={{ flex: "1", textAlign: "center" }}>View</div>
            </div>

            {/* Rows */}
            {allRolesData.map((role) => (
              <div
                key={role.id}
                style={{
                  display: "flex",
                  borderBottom: "1px solid #f0f0f0",
                  padding: "10px 5px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "2", paddingLeft: "10px" }}>{role.role_Mstr_Name}</div>

                <div style={{ flex: "1", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={role.isView}
                    onChange={() => handlePermissionChange(role.id, "isView")}
                  />
                </div>
              </div>
            ))}

            <button
              onClick={onSaveRoleAccess}
              style={{
                marginTop: "25px",
                width: "100%",
                backgroundColor: "#02ACF6",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                height: "35px",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              Save
            </button>
          </div>
        )}
        {activeTab === 2 && currentTab === "Subflow" && (
          <div
            style={{
              width: "350px",
              border: "1px solid #ddd",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                borderBottom: "1px solid #ddd",
                fontWeight: "bold",
                padding: "10px 5px",
              }}
            >
              <div style={{ flex: "2", paddingLeft: "10px", width: "80px" }}>Role</div>

              <div style={{ flex: "1", textAlign: "center" }}>
                {permissions.includes(1) ? "View" : ""}
              </div>
              <div style={{ flex: "1", textAlign: "center" }}>
                {permissions.includes(2) ? "Add" : ""}
              </div>
              <div style={{ flex: "1", textAlign: "center" }}>
                {permissions.includes(3) ? "Edit" : ""}
              </div>
              <div style={{ flex: "1", textAlign: "center" }}>
                {permissions.includes(4) ? "Delete" : ""}
              </div>
              <div style={{ flex: "1", textAlign: "center" }}>
                {permissions.includes(5) ? "Execute" : ""}
              </div>
            </div>

            {/* Rows */}
            {allRolesData.map((role) => (
              <div
                key={role.id}
                style={{
                  display: "flex",
                  borderBottom: "1px solid #f0f0f0",
                  padding: "10px 5px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "2", paddingLeft: "10px", width: "80px" }}>
                  {role.role_Mstr_Name}
                </div>

                <div style={{ flex: "1", textAlign: "center" }}>
                  {permissions.includes(1) ? (
                    <input
                      type="checkbox"
                      checked={role.isView}
                      onChange={() =>
                        handlePermissionChange(role.id, "isView")
                      }
                    />
                  ) : (
                    <span>&nbsp;</span>
                  )}
                </div>

                <div style={{ flex: "1", textAlign: "center" }}>
                  {permissions.includes(2) ? (
                    <input
                      type="checkbox"
                      checked={role.isAdd}
                      onChange={() =>
                        handlePermissionChange(role.id, "isAdd")
                      }
                    />
                  ) : (
                    <span>&nbsp;</span>
                  )}
                </div>

                <div style={{ flex: "1", textAlign: "center" }}>
                  {permissions.includes(3) ? (
                    <input
                      type="checkbox"
                      checked={role.isEdit}
                      onChange={() =>
                        handlePermissionChange(role.id, "isEdit")
                      }
                    />
                  ) : (
                    <span>&nbsp;</span>
                  )}
                </div>

                <div style={{ flex: "1", textAlign: "center" }}>
                  {permissions.includes(4) ? (
                    <input
                      type="checkbox"
                      checked={role.isDelete}
                      onChange={() =>
                        handlePermissionChange(role.id, "isDelete")
                      }
                    />
                  ) : (
                    <span>&nbsp;</span>
                  )}
                </div>

                <div style={{ flex: "1", textAlign: "center" }}>
                  {permissions.includes(5) ? (
                    <input
                      type="checkbox"
                      checked={role.isExecute}
                      onChange={() =>
                        handlePermissionChange(role.id, "isExecute")
                      }
                    />
                  ) : (
                    <span>&nbsp;</span>
                  )}
                </div>
              </div>
            ))}



            <button
              onClick={onSaveRoleAccess}
              style={{
                marginTop: "25px",
                width: "100%",
                backgroundColor: "#02ACF6",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                height: "35px",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              Save
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PropertiesTab;
